// extracted by mini-css-extract-plugin
module.exports = {"table":"log-list_table_3LSfU"};